import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const previewHighlights = [
  "Strengthen internal processes & operations",
  "Build a long-term development strategy",
  "Enhance team capacity with expert-led sessions",
  "Improve decision-making and planning",
  "Customized support based on your stage of growth",
];

const CapacityPreview = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Title */}
        <motion.h2
          className="text-4xl md:text-5xl font-heading font-extrabold text-primary mb-12 tracking-tight"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          NGO Capacity Building Program
        </motion.h2>

        {/* Introductory Text */}
        <motion.p
          className="text-lg md:text-xl text-gray-700 mb-12 mx-auto max-w-3xl leading-relaxed"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Empowering Social Organizations for Long-Term Impact. Our program is designed to support grassroots organizations in building robust systems, strengthening leadership, and enhancing their ability to deliver meaningful impact.
        </motion.p>

        {/* Highlights Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mb-12">
          {previewHighlights.map((point, i) => (
            <motion.div
              key={i}
              className="glass-card p-8 bg-white shadow-xl rounded-xl hover:scale-105 transform transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
            >
              <div className="flex items-center justify-center mb-6">
                <CheckCircle className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-primary mb-4">{point}</h3>
            </motion.div>
          ))}
        </div>

        {/* Call to Action Section */}
        <motion.div
          className="mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <a
            href="#"
            className="inline-block bg-primary text-white text-lg font-semibold px-8 py-4 rounded-xl hover:bg-secondary transform transition duration-300"
          >
            Learn More About the Program
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CapacityPreview;
